import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";

const STATUSES = ["confirmed", "preparing", "ready", "completed", "cancelled"];
const STATUS_COLORS = {
  confirmed: "bg-blue-100 text-blue-700",
  preparing: "bg-amber-100 text-amber-700",
  ready: "bg-emerald-100 text-emerald-700",
  completed: "bg-gray-200 text-gray-700",
  cancelled: "bg-rose-100 text-rose-700",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/orders").then(r => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/orders/${id}/status`, { status }); toast.success("Status updated"); load(); }
    catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div data-testid="admin-orders">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl">Orders</h1>
          <p className="text-gray-500 mt-1 text-sm">{orders.length} paid orders</p>
        </div>
      </div>

      <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-100">
              <tr className="text-left">
                {["Customer", "Username", "Box", "Flavors", "Method", "Address", "Distance", "Subtotal", "Delivery", "Tip", "Total", "Date", "Status"].map(h => (
                  <th key={h} className="px-3 py-3 text-xs uppercase tracking-wider font-bold text-gray-500">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading && <tr><td colSpan="13" className="p-6 text-center text-gray-500">Loading...</td></tr>}
              {!loading && orders.length === 0 && <tr><td colSpan="13" className="p-6 text-center text-gray-500">No orders yet.</td></tr>}
              {orders.map(o => (
                <tr key={o.id} className="hover:bg-gray-50" data-testid={`order-row-${o.id}`}>
                  <td className="px-3 py-3 font-semibold">{o.full_name}</td>
                  <td className="px-3 py-3 text-gray-600">{o.username}</td>
                  <td className="px-3 py-3">{o.box_size}</td>
                  <td className="px-3 py-3 text-xs">{o.items.map(it => `${it.quantity}× ${it.flavor_name}`).join(", ")}</td>
                  <td className="px-3 py-3 capitalize">{o.method}</td>
                  <td className="px-3 py-3 text-xs text-gray-600">{o.method === "delivery" ? `${o.address_street}, ${o.address_city}${o.address_state ? `, ${o.address_state}` : ""} ${o.address_zip}` : "—"}</td>
                  <td className="px-3 py-3 text-xs">{o.method === "delivery" && o.distance_miles ? `${o.distance_miles.toFixed(1)} mi` : "—"}</td>
                  <td className="px-3 py-3">${o.subtotal.toFixed(2)}</td>
                  <td className="px-3 py-3">${o.delivery_fee.toFixed(2)}</td>
                  <td className="px-3 py-3">${o.tip.toFixed(2)}</td>
                  <td className="px-3 py-3 font-bold">${o.total.toFixed(2)}</td>
                  <td className="px-3 py-3 text-xs text-gray-600">{new Date(o.created_at).toLocaleDateString()}</td>
                  <td className="px-3 py-3">
                    <select
                      value={o.status}
                      onChange={(e) => setStatus(o.id, e.target.value)}
                      className={`text-xs font-bold px-2 py-1 rounded-full border-0 cursor-pointer ${STATUS_COLORS[o.status] || "bg-gray-100"}`}
                      data-testid={`order-status-${o.id}`}
                    >
                      {STATUSES.map(s => <option key={s} value={s}>{s.toUpperCase()}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
